/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_TranslationInputs */

const en_automatic_translation = /** @type {(inputs: Automatic_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Translation`)
};

const fr_automatic_translation = /** @type {(inputs: Automatic_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduction automatique`)
};

const de_automatic_translation = /** @type {(inputs: Automatic_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Übersetzung`)
};

const it_automatic_translation = /** @type {(inputs: Automatic_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduzione automatica`)
};

const ru_automatic_translation = /** @type {(inputs: Automatic_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматический перевод`)
};

const es_automatic_translation = /** @type {(inputs: Automatic_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traducción automática`)
};

const zh_cn2_automatic_translation = /** @type {(inputs: Automatic_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动翻译`)
};

const ja_automatic_translation = /** @type {(inputs: Automatic_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動翻訳`)
};

const hi_automatic_translation = /** @type {(inputs: Automatic_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित अनुवाद`)
};

const pt_pt2_automatic_translation = /** @type {(inputs: Automatic_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tradução automática`)
};

/**
* | output |
* | --- |
* | "Automatic Translation" |
*
* @param {Automatic_TranslationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_translation = /** @type {((inputs?: Automatic_TranslationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_TranslationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_translation(inputs)
	if (locale === "de") return de_automatic_translation(inputs)
	if (locale === "it") return it_automatic_translation(inputs)
	if (locale === "ru") return ru_automatic_translation(inputs)
	if (locale === "es") return es_automatic_translation(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_translation(inputs)
	if (locale === "ja") return ja_automatic_translation(inputs)
	if (locale === "hi") return hi_automatic_translation(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_translation(inputs)
	return en_automatic_translation(inputs)
});